const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PASSWORD_PATTERN = /^(?=.*[A-Za-z])(?=.*\d).{6,}$/;

export function validateSignUpFields({ name, email, password }) {
  const errors = { name: "", email: "", password: "" };
  const trimmedName = name.trim();

  if (!trimmedName) {
    errors.name = "Full name cannot be blank. Minimum 3 characters required.";
  } else if (trimmedName.length < 3) {
    errors.name = "Minimum 3 characters required for full name.";
  } else if (trimmedName.length > 50) {
    errors.name = "Full name cannot exceed 50 characters.";
  }

  const trimmedEmail = email.trim();
  if (!trimmedEmail || !EMAIL_PATTERN.test(trimmedEmail)) {
    errors.email = "Please enter a valid email address.";
  }

  if (!password || !PASSWORD_PATTERN.test(password)) {
    errors.password =
      "Password must be at least 6 characters and contain at least one letter and one number.";
  }

  return errors;
}
